<div class="grid" *ngIf="!this.isLoading">
    <img alt="type" [src]="this.image"/>
    <p class="text" [class.dark-mode]="this.darkMode">{{this.number}}</p>
</div>